import { createProject } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { sales_coordinator, coordinator, account_manager, client, ...rest } = values;

  const payload = {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null && _ !== "tags"
      )
    ),

    sales_coordinator: sales_coordinator.id || sales_coordinator,
    account_manager: account_manager?.id || account_manager,
    coordinator: coordinator?.id || coordinator,

    client: client?.id || client,
    status: values.status,
  };

  if (Array.isArray(values.tags)) {
    payload.tags = values.tags.map((t) => ({
      tag: typeof t === "object" ? t?.id : t,
    }));
  }

  return payload;
}

export function useCreateProject() {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);

      try {
        const response = await createProject({ item: payload });
        return response;
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      toast.success("Project Created Successfully");
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
